import React, { Component } from 'react';

import Section from './Section';

export default class Debug extends Component {
    renderToken(key) {
        const json = localStorage.getItem('token.' + key);
        if (!json) return null;

        return <Section key={key} title={key}><pre>{JSON.stringify(JSON.parse(json), null, 2)}</pre></Section>;
    }

    render() {
        return [ 'blizzard', 'patreon', 'twitch' ].map(key => this.renderToken(key));
    }
}